import React from 'react'
import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'
import { CellSignal, CELL_SIGNALS, CELL_SIGNAL_STATUS } from '../../utils/mappingLevel'

// Explains the CellSignalDot markers used in the wizard grid cells.
const LEGEND_FALLBACK: Record<CellSignal, string> = {
  linked: 'jo linkitetty',
  suggestion: 'ehdotus',
  none: 'ei osumaa'
}

const CellSignalLegend: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', gap: 16, fontSize: 11, color: '#666', marginBottom: 12 }}>
      {CELL_SIGNALS.map(signal => (
        <Badge
          key={signal}
          status={CELL_SIGNAL_STATUS[signal]}
          text={t(`groupCustomerMapping:cellSignal-${signal}`, LEGEND_FALLBACK[signal])}
        />
      ))}
    </div>
  )
}

export default CellSignalLegend
